import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
import PageLoader from '@components/ui/PageLoader';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRole?: 'admin' | 'viewer';
}

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, profile } = useAuth();
  const location = useLocation();

  if (isLoading) return <PageLoader />;

  // Not signed in — send to the login page and remember where they were headed.
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;

  if (requiredRole && profile?.role !== requiredRole) return <Navigate to="/" replace />;

  return <>{children}</>;
}
